import type { LegalEntity } from '@/types/api'
import { createCrudService } from '../crud'

// No code: the backend makes one up (the «Фирмы» form does not show it).
export type LegalEntityInput = Pick<LegalEntity, 'name' | 'batch_letter' | 'tin' | 'address' | 'status' | 'parent_group_id'>

export const legalEntitiesService = createCrudService<LegalEntity, LegalEntityInput, Partial<LegalEntityInput>>(
  'parties/legal-entities',
)
